import { render } from "./FD2024ExcerptSection.vue?vue&type=template&id=17a69526"
import script from "./FD2024ExcerptSection.vue?vue&type=script&lang=js"
export * from "./FD2024ExcerptSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__